<template>
    <div>
        <auth-container v-if="$route.name === 'SrReports'" :page="page">
            <h2 class="mb-4">O&amp;M Reports</h2>

			<ul>
				<li><router-link to="/sr/reports/projects">Project Summary (A&amp;E)</router-link></li>
				<li><router-link to="/sr/reports/projectstatus">Project Status</router-link></li>
				<li><router-link to="/sr/reports/programperformance">Program Performance</router-link></li>
				<li><router-link to="/sr/reports/expiringcontracts">Expiring Contracts</router-link></li>
				<li><router-link to="/sr/reports/dams">Dams</router-link></li>
				<li><router-link to="/sr/reports/twdb">TWDB</router-link></li>
			</ul>
            
        </auth-container>
        <router-view></router-view>
    </div>
</template>

<script>
	export default {
        name: 'SrReports',
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false,
					noData: false
				}
			}
		}
	}
</script>